/*
 |--------------------------------------------------------------------------
 | Closeable module
 |
 | <div class="js-closeable">
 |  <button type="button" "js-closeable-button">close</button> <-- removes parent ".js-closebale"-element
 | </div>
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 IMPORTS
\* ========================================================================== */

import $ from 'jquery';

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
 CONSTANTS
\* ========================================================================== */

const
    /**
     * The module name
     * @type {String}
     */
    moduleName = 'closeable',
    /**
     * Lookup table for selectors
     * @type {Object}
     */
    selectors = {
        base: `.js-${ moduleName }`,
    };

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
 INITIALIZATION
\* ========================================================================== */

$(document).on("click", ".js-closeable-button", function() {
    const parent = $(this).parents('.js-closeable');
    parent.addClass('u-display-none');
});

/* == END INITIALIZATION ==================================================== */